__turbopack_context__.v({
  "SExtraProgramControls": "_7sq-LW_SExtraProgramControls",
  "SFilmwebIdButtonPanel": "_7sq-LW_SFilmwebIdButtonPanel",
  "SGalleryButton": "_7sq-LW_SGalleryButton",
  "SGallerySvg": "_7sq-LW_SGallerySvg",
  "SIconText": "_7sq-LW_SIconText",
  "STrailerButton": "_7sq-LW_STrailerButton",
});
